import React from 'react';
import { Box, Typography, Button, CircularProgress, Alert } from '@mui/material';

interface LoadingErrorBoundaryProps {
    loading: boolean;
    error: string | null;
    onRetry?: () => void;
    children: React.ReactNode;
}

const LoadingErrorBoundary: React.FC<LoadingErrorBoundaryProps> = ({
    loading,
    error,
    onRetry,
    children,
}) => {
    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ py: 2 }}>
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
                {onRetry && (
                    <Button variant="outlined" onClick={onRetry}>
                        Retry
                    </Button>
                )}
            </Box>
        );
    }

    return <>{children}</>;
};

export default LoadingErrorBoundary; 